module.exports = __webpack_public_path__ + "img/clientes_mobile.0acfea0e.svg";